import * as React from 'react'
import HotTable from 'react-handsontable'
import Handsontable from "handsontable"
import { ChartData, ChartOptions } from 'chart.js'
import { injectIntl, InjectedIntlProps } from 'react-intl'
import { Bar,Pie } from 'react-chartjs-2'
import { LocalAuthority, LoanWithDecomposition } from '../../../model'
import { ColorsHelper } from '../../../util/colors'
import { fontAwesomeRenderer, linkRenderer } from '../../utils/handsontable/renderers'
import { CardModal, CardModalType } from "../../modal"
import * as _ from 'lodash'
import "./../style.scss";

class DebtDecompositionComponent
extends React.Component<DebtDecompositionComponentProps & InjectedIntlProps,State> {
	private readonly chartOptions: ChartOptions
	private readonly pieChartOption: ChartOptions

	constructor(props) {
		super(props)
		this.chartOptions = this.getChartOptions()
		this.pieChartOption = this.getPieChartOption()
		this.state={
			slectedYear : new Date().getFullYear()
		}
	}

	render() {
		const displayGraphic = this.props.displayGraphic
		const switchGraph = this.props.switchGraph
		return <div className="singled">
				{this.props.data.length === 0 ?
				<div className="generate-loader">
					<span>Aucune données trouvées</span>
				</div> : <HotTable settings={this.getHotSettings()}/>
				}
				
					<br />
					{}
					{displayGraphic && (switchGraph == 'bar' ? <CardModal
						active={true}
						paddingLess={false}
						title={this.props.title}
						type={CardModalType.Switch}
						graph={switchGraph}
						isFluid
						onClickCloseButton={e => this.props.onClickCloseButton(e)}
						onClickFooterButton={(b, e) => this.props.onClickSwitchButton(e)}
						onSubmit={e => this.props.onClickCloseButton(e)}>
					<div style={{ position: "relative", height: "350px" }}>
						<Bar data={this.getChartData(this.props)} options={this.chartOptions} />
					</div>
				</CardModal>:
				 <CardModal
			       active={true}
				   paddingLess={false}
				   title={this.props.title}
				   type={CardModalType.Switch}
				   isFluid
				   graph={switchGraph}
				   onClickCloseButton={e => this.props.onClickCloseButton(e)}
				   onClickFooterButton={(b, e) => this.props.onClickSwitchButton(e)}
				   onSubmit={e => this.props.onClickCloseButton(e)}>
					<select value={this.state.slectedYear} onChange={(e)=>this.selectYear(e)} style={{width:'10rem'}} >
					{this.props.years.map((res,i)=><option key={i}>{res}</option>)}	
					</select>
			    <div style={{ position: "relative", height: "350px" }}>
				<Pie data={this.getPieChartData(this.props)}  options={this.pieChartOption}/>
			     </div>
		        </CardModal>)}

				</div>
	}

	private selectYear(e){
      this.setState({slectedYear:e.target.value})
	}

	private getPieChartData(props: DebtDecompositionComponentProps){
		if (props.loading) return
		const data: ChartData = {}
		data.labels = ["Dette normale",'Dette normale récupérable','Dette simulée','Dette simulée']
		data.datasets = [
			{
				label: new Date().getFullYear().toString(),
				backgroundColor: ["#B2CB3B","#5F8949","#F05B06","#BB2307"],
				data:[props.data.reduce((prev, row) => row &&  row.linkNumber != "Total" && row.linkNumber != 'Dette normale récupérable' &&
					row.linkNumber != 'Dette normale' &&row.linkNumber != 'Total Dette' &&row.linkNumber != 'Total dette simulée' &&
					row.linkNumber != 'Dette simulée récupérable' &&row.linkNumber != 'Dette simulée' 
					&& row.linkSubject != 'Dette normale' && row.linkSubject != 'Dette normale récupérable' && row.linkSubject != 'Dette simulée récupérable' && 
					row.linkSubject != 'Dette simulée' && row.loanWithDecomposition.loan && !row.loanWithDecomposition.loan.simulate && !row.loanWithDecomposition.loan.detteRecuperable? row[this.state.slectedYear] + prev : prev, 0),
				   
					props.data.reduce((prev, row) => row &&  row.linkNumber != "Total" && row.linkNumber != 'Dette normale récupérable' &&
					row.linkNumber != 'Dette normale' &&row.linkNumber != 'Total Dette' &&row.linkNumber != 'Total dette simulée' &&
					row.linkNumber != 'Dette simulée récupérable' &&row.linkNumber != 'Dette simulée' 
					&& row.linkSubject != 'Dette normale' && row.linkSubject != 'Dette normale récupérable' && row.linkSubject != 'Dette simulée récupérable' && 
					row.linkSubject != 'Dette simulée' && row.loanWithDecomposition.loan && !row.loanWithDecomposition.loan.simulate && row.loanWithDecomposition.loan.detteRecuperable? row[this.state.slectedYear] + prev : prev, 0),
				
                    props.data.reduce((prev, row) => row &&  row.linkNumber != "Total" && row.linkNumber != 'Dette normale récupérable' &&
					row.linkNumber != 'Dette normale' &&row.linkNumber != 'Total Dette' &&row.linkNumber != 'Total dette simulée' &&
					row.linkNumber != 'Dette simulée récupérable' &&row.linkNumber != 'Dette simulée' 
					&& row.linkSubject != 'Dette normale' && row.linkSubject != 'Dette normale récupérable' && row.linkSubject != 'Dette simulée récupérable' && 
					row.linkSubject != 'Dette simulée' && row.loanWithDecomposition.loan && row.loanWithDecomposition.loan.simulate && !row.loanWithDecomposition.loan.detteRecuperable? row[this.state.slectedYear] + prev : prev, 0),
				
                    props.data.reduce((prev, row) => row && row.loanWithDecomposition.loan && row.loanWithDecomposition.loan.simulate && row.loanWithDecomposition.loan.detteRecuperable ? row[this.state.slectedYear] + prev : prev, 0)]
				
			}
		]
		return data
	}

	private getChartData(props: DebtDecompositionComponentProps): ChartData {
		if (props.loading) return
		const data: ChartData = {}
		data.labels = props.years.map(year => year.toString())

		data.datasets = [
			{
				label: "Dette normale",
				backgroundColor: "#B2CB3B",
				data: data.labels.map((label: string) =>{
				 let dat = props.data.reduce((prev, row) => row &&  row.linkNumber != "Total" && row.linkNumber != 'Dette normale récupérable' &&
					row.linkNumber != 'Dette normale' &&row.linkNumber != 'Total Dette' &&row.linkNumber != 'Total dette simulée' &&
					row.linkNumber != 'Dette simulée récupérable' &&row.linkNumber != 'Dette simulée' 
					&& row.linkSubject != 'Dette normale' && row.linkSubject != 'Dette normale récupérable' && row.linkSubject != 'Dette simulée récupérable' && 
					row.linkSubject != 'Dette simulée' && row.loanWithDecomposition.loan && !row.loanWithDecomposition.loan.simulate && !row.loanWithDecomposition.loan.detteRecuperable? row[parseInt(label)] + prev : prev, 0)				
				return dat
				}
					),
				
			},{
				label: 'Dette normale récupérable',
				backgroundColor: "#5F8949",
				data: data.labels.map((label: string) =>{
				 let dat = props.data.reduce((prev, row) => row &&  row.linkNumber != "Total" && row.linkNumber != 'Dette normale récupérable' &&
					row.linkNumber != 'Dette normale' &&row.linkNumber != 'Total Dette' &&row.linkNumber != 'Total dette simulée' &&
					row.linkNumber != 'Dette simulée récupérable' &&row.linkNumber != 'Dette simulée' 
					&& row.linkSubject != 'Dette normale' && row.linkSubject != 'Dette normale récupérable' && row.linkSubject != 'Dette simulée récupérable' && 
					row.linkSubject != 'Dette simulée' && row.loanWithDecomposition.loan && !row.loanWithDecomposition.loan.simulate && row.loanWithDecomposition.loan.detteRecuperable? row[parseInt(label)] + prev : prev, 0)				
				return dat
				}
					),
				
			},{
				label: 'Dette simulée',
				backgroundColor: "#F05B06",
				data: data.labels.map((label: string) =>{
				 let dat = props.data.reduce((prev, row) => row &&  row.linkNumber != "Total" && row.linkNumber != 'Dette normale récupérable' &&
					row.linkNumber != 'Dette normale' &&row.linkNumber != 'Total Dette' &&row.linkNumber != 'Total dette simulée' &&
					row.linkNumber != 'Dette simulée récupérable' &&row.linkNumber != 'Dette simulée' 
					&& row.linkSubject != 'Dette normale' && row.linkSubject != 'Dette normale récupérable' && row.linkSubject != 'Dette simulée récupérable' && 
					row.linkSubject != 'Dette simulée' && row.loanWithDecomposition.loan && row.loanWithDecomposition.loan.simulate && !row.loanWithDecomposition.loan.detteRecuperable? row[parseInt(label)] + prev : prev, 0)				
				return dat
				}
					),
				
			},
			{
				label: "Dette simulée récupérable",
				backgroundColor: "#BB2307",
				data: data.labels.map((label: string) =>{
				let dat =	props.data.reduce((prev, row) => row && row.loanWithDecomposition.loan && row.loanWithDecomposition.loan.simulate && row.loanWithDecomposition.loan.detteRecuperable ? row[parseInt(label)] + prev : prev, 0)
					return dat
					}
					),
				
			}
		]
		return data
	}

	private getPieChartOption(): ChartOptions {
		return{
			tooltips: { callbacks: {
				label: (tooltip, data) => {
					const datasetIndex = tooltip.datasetIndex
					const dataIndex = tooltip.index
					const datasetData = data.datasets[datasetIndex].data as number[]
					const value = datasetData[dataIndex]
					const formattedValue = this.props.intl.formatNumber(value, { currency: "EUR", style: "currency" })
					return `${this.props.title} : ${formattedValue}`
				},
				title: ([tooltip], data) => {
					const datasetIndex = tooltip.datasetIndex
					const year = tooltip.xLabel
					const datasetLabel = data.datasets[datasetIndex].label
					return `${datasetLabel} en ${year}`
				}
			}}
		}
	}

	private getChartOptions(): ChartOptions {
		return {
			legend: { display: true,position:'top' },
			maintainAspectRatio: false,
			scales: {
				xAxes: [{ offset: true, stacked: true }],
				yAxes: [{
					ticks: { callback: value => (
						this.props.intl.formatNumber(value, { currency: "EUR", style: "currency" })
					)},
					stacked: true
				}]
			},
			tooltips: { callbacks: {
				label: (tooltip, data) => {
					const datasetIndex = tooltip.datasetIndex
					const dataIndex = tooltip.index
					const datasetData = data.datasets[datasetIndex].data as number[]
					const value = datasetData[dataIndex]
					const formattedValue = this.props.intl.formatNumber(value, { currency: "EUR", style: "currency" })
					return `${this.props.title} : ${formattedValue}`
				},
				title: ([tooltip], data) => {
					const datasetIndex = tooltip.datasetIndex
					const year = tooltip.xLabel
					const datasetLabel = data.datasets[datasetIndex].label
					return `${datasetLabel} en ${year}`
				}
			}}
		}
	}

	private getHotColumns(): any[] {
		const displaySimulate = this.props.displaySimulate
		const years    = this.props.years
		return displaySimulate ? [
			{
				data: "loanWithDecomposition"
			},
			{
				data: "linkNumber"
			},
			{
				data: "linkSubject"
			},
			...this.getYearsColumns(years)
		] : [
			{
				data: "linkNumber"
			},
			{
				data: "linkSubject"
			},
			...this.getYearsColumns(years)
		]
	}

	/*table setting */
	private getHotSettings(): {} {
		const data = this.props.data
		const cells = function(row, col, prop) {
			// getting source data of the row
			const rowData  = this.instance.getSourceDataAtRow(row)
			const loan = rowData && rowData.loanWithDecomposition && rowData.loanWithDecomposition.loan
			const simulate =  loan && rowData.loanWithDecomposition.loan.simulate
			const loanSubject = loan && rowData.loanWithDecomposition.loan.subject
			const loanNumber = rowData && rowData.loanWithDecomposition && rowData.loanWithDecomposition.loan.number
			// creating cell properties
			const cellProps: any = {}
			cellProps.renderer = function(instance, TD, row, col2, prop2, value, cellProperties) {
				switch(prop2) {
					case "linkNumber":
						linkRenderer(instance, TD, row, col2, prop2, value, cellProperties, loanNumber,"num",data,loan)
						break
					case "linkSubject":
						linkRenderer(instance, TD, row, col2, prop2, value, cellProperties, loanSubject,"str",data,loan)
						break
					case "loanWithDecomposition":
						fontAwesomeRenderer(instance, TD, row, col2, prop2, rowData.loanWithDecomposition, cellProperties)
						break
					default:
						if(row === data.length -7){
							Handsontable.renderers.NumericRenderer.apply(this, arguments)
							TD.style.backgroundColor = "#B2CB3B";
							TD.style.color = "white"
						}else if(row === data.length - 6){
							Handsontable.renderers.NumericRenderer.apply(this, arguments)
							TD.style.backgroundColor = "#5F8949";
							TD.style.color = "white"
						}else if(row === data.length - 5){
							Handsontable.renderers.NumericRenderer.apply(this, arguments)
							TD.style.backgroundColor = "lightGray";
							TD.style.color = "white"
						}else if(row === data.length - 4){
							Handsontable.renderers.NumericRenderer.apply(this, arguments)
							TD.style.backgroundColor = "#BB2307";
							TD.style.color = "white"
						}else if(row === data.length - 3){
							Handsontable.renderers.NumericRenderer.apply(this, arguments)
							TD.style.backgroundColor = "#F05B06";
							TD.style.color = "white"
						}else if(row === data.length - 2){
							Handsontable.renderers.NumericRenderer.apply(this, arguments)
							TD.style.backgroundColor = "lightGray";
							TD.style.color = "white"
						}else{
							Handsontable.renderers.NumericRenderer.apply(this, arguments)
						}
				}
				if (simulate) TD.classList.add('debt-simulate')
			}
			return cellProps
		}
		const displaySimulate = this.props.displaySimulate
		const years = this.props.years
		const colHeaders = displaySimulate ? [
			"●",
			"N°",
			"Objet",
			...years.map(String)
		] : [
			"N°",
			"Objet",
			...years.map(String)
		]
		const fixedCols = displaySimulate ? 3 : 2

		return {
			cells,
			colHeaders: colHeaders,
			rowHeaders: displaySimulate,
			columns: this.getHotColumns(),
			data: this.props.data,
			fixedColumnsLeft: fixedCols,
			width: '100%',
			height: 600,
			readOnly: true,
			stretchH: 'all',
			preventOverflow: 'vertical',
			// colWidths: function(index) {
			// 	if (index === 0) {
			// 		return 50;
			// 	}

			// 	if (index >= 3) {
			// 		return 150;
			// 	}

			// 	return 300;
			// },
			viewportColumnRenderingOffset: 20,
			viewportRowRenderingOffset: 70,
		}
	}

	private getYearsColumns = (years) => {
		const columns   = []
		const firstYear = years[0]

		for (let i = firstYear; i < firstYear + years.length; i++) {
			columns.push({ data: i.toString(), format: "0,0.00 $", language: "fr-FR", type: "numeric" })
		}

		return columns
	}
}

export default injectIntl(DebtDecompositionComponent)

export enum DecompositionType {
	Analysis,
	Annuity,
	Interest,
	ReimboursedCapital,
	RemainingCapital
}

export interface DataRow {
	loanWithDecomposition: LoanWithDecomposition
	linkSubject: string
	linkNumber: string
	isTitle?: boolean
	[year: number]: number
}

export interface DebtDecompositionComponentProps {
	data: DataRow[],
	displayGraphic: boolean,
	displaySimulate: boolean,
	displaySimulateRécupérable: boolean,
	displayDette: boolean,
	displayDetteSimuléeRécupérable: boolean,
	loading: boolean,
	localAuthority: LocalAuthority,
	onClickCloseButton(e: React.SyntheticEvent<Element>): any,
	onClickSwitchButton(e: React.SyntheticEvent<Element>): any,
	title: string,
	switchGraph:string,
	type: DecompositionType,
	years: number[]
}

interface State {
	slectedYear:number
}


// WEBPACK FOOTER //
// ./src/component/debt/debt-decomposition/debt-decomposition-component.tsx